// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"af978425","589":"44c23db3"}[chunkId] + ".css";
};